import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import { SENSOR_PLACEMENT_CONFIG } from '@awp/constants';
import { isValueEmpty } from '@awp/helpers/utilsReact';

const sotitalicColStyle = {
  fontSize: '85%',
  fontStyle: 'italic',
  color: '#6c757d',
  borderTop: '0.063rem solid #bdc5cc',
  borderLeft: '0.063rem solid #bdc5cc',
  paddingTop: '0.2rem',
  paddingBottom: '0.2rem',
};
const sotColStyle = {
  borderTop: '0.063rem solid #bdc5cc',
  borderLeft: '0.063rem solid #bdc5cc',
  paddingTop: '0.2rem',
  paddingBottom: '0.2rem',
  fontSize: '85%',
};
const sotTitleStyle = {
  paddingTop: '0.6rem',
  paddingBottom: '0.6rem',
  display: 'flex',
  alignItems: 'center',
};
const sotOutline = {
  outline: '0.063rem solid black',
  padding: '0rem 1rem',
  outlineOffset: '-0.063rem',
};
const TemplateObservationTypeInfo = ({ tot, isMultiMode }) => {
  return (
    tot && (
      <Row className="bg-white">
        <Col style={sotColStyle} md={4}>
          {tot.ObservationTypeName}
        </Col>
        {!isValueEmpty(tot.DisplayName) ? (
          <Col style={sotColStyle} md={4}>
            {tot.DisplayName}
          </Col>
        ) : (
          <Col style={sotitalicColStyle} md={4}>
            {tot.ObservationTypeDisplayName}
          </Col>
        )}
        {isMultiMode && (
          <Col style={sotColStyle} md={4}>
            {tot.OffsetElevationMillimetres}
          </Col>
        )}
      </Row>
    )
  );
};

TemplateObservationTypeInfo.propTypes = {
  tot: PropTypes.any.isRequired,
};

export default TemplateObservationTypeInfo;
